module.exports = __webpack_public_path__ + "img/logosb.06242d7d.png";